import { MetaData, MetaContent, MetaIcon } from "./styles";

const metaData = [
    { key: 'immediateSubcategoryCount', getLabel: (count) => count === 1 ? 'category' : 'categories', icon: 'folder' },
    { key: 'immediateArticleCount', getLabel: (count) => count === 1 ? 'article' : 'articles', icon: 'article' }
];

export const CategoryMeta = ({ categoryData }) => {
    return (
        <MetaData>
            {metaData.map(({ key, getLabel, icon }) => {
                const value = categoryData[key];
                if (!value) return null;
                return (
                    <MetaContent key={key}>
                        <MetaIcon className="material-icons-outlined">{icon}</MetaIcon>
                        {value} {getLabel(value)}
                    </MetaContent>
                );
            })}
        </MetaData>
    );
};